import { useState } from "react";
import styles from "./AdminMenuPanel.module.css";
import {
  FaLayerGroup,
  FaAngleDown,
  FaAngleRight,
  FaUsers,
  FaHome,
} from "react-icons/fa";
import useDashboardStore from "../../store/dashboardStore";

const AdminMenuPanel = () => {
  const [openCommunities, setOpenCommunities] = useState(true);
  const [openChannels, setOpenChannels] = useState(true);
  const [openLiveSessions, setOpenLiveSessions] = useState(true);
  const [openHomeSections, setOpenHomeSections] = useState(true);

  const {
    setIsCreateCommunityScreen,
    setIsAllCommunityScreen,
    setIsCreateChannelScreen,
    setIsAllChannelScreen,
    setIsCreateLiveSessionScreen,
    setIsAllLiveSessionScreen,
    setIsAllHomeSectionScreen,
    setIsCreateHomeSectionScreen,
    setIsUsersScreen,
    setEditCommunityId,
    setEditChannelId,
    setEditLiveSession,
    setEditHomeSectionId,
    isAllCommunityScreen,
    isCreateCommunityScreen,
    isAllChannelScreen,
    isCreateChannelScreen,
    isAllLiveSessionScreen,
    isCreateLiveSessionScreen,
    isAllHomeSectionScreen,
    isCreateHomeSectionScreen,
  } = useDashboardStore();

  return (
    <div className={styles.panelWrapper}>
      {/* <div className={styles.menuItem}>
                <FaTachometerAlt className={styles.icon} />
                <span>Dashboard</span>
            </div> */}

      <div
        className={styles.menuItem}
        onClick={() => setOpenCommunities(!openCommunities)}
      >
        <FaLayerGroup className={styles.icon} />
        <span>Communities</span>
        {openCommunities ? (
          <FaAngleDown className={styles.arrow} />
        ) : (
          <FaAngleRight className={styles.arrow} />
        )}
      </div>
      {openCommunities && (
        <div className={styles.subMenu}>
          <div
            className={
              isAllCommunityScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => setIsAllCommunityScreen(true)}
          >
            All Communities
          </div>
          <div
            className={
              isCreateCommunityScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => {
              setIsCreateCommunityScreen(true);
              setEditCommunityId(null);
            }}
          >
            Add Community
          </div>
        </div>
      )}

      <div
        className={styles.menuItem}
        onClick={() => setOpenChannels(!openChannels)}
      >
        <FaLayerGroup className={styles.icon} />
        <span>Channels</span>
        {openChannels ? (
          <FaAngleDown className={styles.arrow} />
        ) : (
          <FaAngleRight className={styles.arrow} />
        )}
      </div>
      {openChannels && (
        <div className={styles.subMenu}>
          <div
            className={
              isAllChannelScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => setIsAllChannelScreen(true)}
          >
            All Channels
          </div>
          <div
            className={
              isCreateChannelScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => {
              setIsCreateChannelScreen(true);
              setEditChannelId(null);
            }}
          >
            Add Channel
          </div>
        </div>
      )}

      <div
        className={styles.menuItem}
        onClick={() => setOpenLiveSessions(!openLiveSessions)}
      >
        <FaLayerGroup className={styles.icon} />
        <span>Live sessions</span>
        {openLiveSessions ? (
          <FaAngleDown className={styles.arrow} />
        ) : (
          <FaAngleRight className={styles.arrow} />
        )}
      </div>
      {openLiveSessions && (
        <div className={styles.subMenu}>
          <div
            className={
              isAllLiveSessionScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => setIsAllLiveSessionScreen(true)}
          >
            All Sessions
          </div>
          <div
            className={
              isCreateLiveSessionScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => {
              setIsCreateLiveSessionScreen(true);
              setEditLiveSession(null);
            }}
          >
            Add Session
          </div>
        </div>
      )}

      {/* Home Sections Menu */}
      <div
        className={styles.menuItem}
        onClick={() => setOpenHomeSections(!openHomeSections)}
      >
        <FaHome className={styles.icon} />
        <span>Home Sections</span>
        {openHomeSections ? (
          <FaAngleDown className={styles.arrow} />
        ) : (
          <FaAngleRight className={styles.arrow} />
        )}
      </div>
      {openHomeSections && (
        <div className={styles.subMenu}>
          <div
            className={
              isAllHomeSectionScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => setIsAllHomeSectionScreen(true)}
          >
            All Home Sections
          </div>
          <div
            className={
              isCreateHomeSectionScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => {
              setIsCreateHomeSectionScreen(true);
              setEditHomeSectionId(null);
            }}
          >
            Add Home Section
          </div>
        </div>
      )}

      <div className={styles.menuItem} onClick={() => setIsUsersScreen(true)}>
        <FaUsers className={styles.icon} />
        <span>Users</span>
      </div>

      {/* <div className={styles.menuItem}>
                <FaCog className={styles.icon} />
                <span>Settings</span>
            </div> */}
    </div>
  );
};

export default AdminMenuPanel;
